import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    template: `
    <ion-header>
      <ion-toolbar>
        @if (!hideDismiss) {
          <ion-buttons slot="start">
            <ion-button (click)="dismiss()">
              <ion-icon name="arrow-back"></ion-icon>
            </ion-button>
          </ion-buttons>
        }
        <tidy-text [title]="'Past Job PDF'"></tidy-text>
        <!-- TODO: Add print button, the function is not working in native -->
        <!-- <ion-buttons slot="end">
          <ion-button (click)="print()">
            <ion-icon name="print"></ion-icon>
          </ion-button>
        </ion-buttons> -->
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <div [innerHTML]="safeContent"></div>
    </ion-content>
  `,
    standalone: false
})
export class PdfViewerComponent implements OnInit {
  @Input() content: string;
  @Input() hideDismiss = false;
  safeContent: SafeHtml;

  constructor(
    private modalCtrl: ModalController,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.safeContent = this.sanitizer.bypassSecurityTrustHtml(this.content);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  print() {
    document.execCommand('print', false, null);
  }
}